import { Box, Grid, Skeleton } from '@factorialco/deprecated-design-system'

import { BasicInformationSkeleton } from './BasicInformation/BasicInformationSkeleton'

export const JobPostingSettingsSkeleton = () => (
  <>
    <Grid variant="fixed">
      <Box gridColSpan={{ xs: 4, s: 4 }} gap="s8">
        {[...Array(6)].map((_, index) => (
          <Skeleton height="s48" width="full" key={index} />
        ))}
      </Box>
      <Box gridColSpan={{ s: 7 }} paddingLeft="s64">
        <BasicInformationSkeleton />
      </Box>
    </Grid>
  </>
)
